/**
 * TanStack Query hooks for `igaming-affiliate-level-ngr-ggr-ftd-report`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingAffiliateLevelNgrGgrFtdReportQueryKeys,
	type CreateIgamingAffiliateLevelNgrGgrFtdReportBody,
	type ListIgamingAffiliateLevelNgrGgrFtdReportResponse,
	type IgamingAffiliateLevelNgrGgrFtdReportRow,
} from "./api";

export function useIgamingAffiliateLevelNgrGgrFtdReportList(): UseQueryResult<ListIgamingAffiliateLevelNgrGgrFtdReportResponse, Error> {
	return useQuery({
		queryKey: igamingAffiliateLevelNgrGgrFtdReportQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingAffiliateLevelNgrGgrFtdReportCreate(): UseMutationResult<IgamingAffiliateLevelNgrGgrFtdReportRow, Error, CreateIgamingAffiliateLevelNgrGgrFtdReportBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingAffiliateLevelNgrGgrFtdReportQueryKeys.all });
		},
	});
}

export function useIgamingAffiliateLevelNgrGgrFtdReportDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingAffiliateLevelNgrGgrFtdReportQueryKeys.all });
		},
	});
}
